import styled from "styled-components";

export const PointScreenContainer = styled.div`
    @media (max-width: 700px) {
        font-size: .7rem;
    }
`;